import { z } from 'zod';
import { dateRangeValidator, periodValidator } from './date-range.validator';
import { pageValidator } from './page.validator.ts';
import { queryValidator } from './query.validator.ts';
import { urlValidator, regexValidator } from './misc.validator.ts';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace Validator {
  export const dateRange = dateRangeValidator;
  export const periodPresetType = periodValidator;
  export const page = pageValidator;
  export const query = queryValidator;
  export const url = urlValidator;
  export const regex = regexValidator;
  export const identifier = (v: unknown) =>
    z.coerce
      .number()
      .int()
      .positive()
      .max(Number.MAX_SAFE_INTEGER, {
        message: '식별자는 양의 정수여야 합니다.',
      })
      .parse(v);
}
